import {Component} from 'react'
import {DirectionButton, ListItem} from './styledComponents'

class GradientDirectionItem extends Component {
  onClickDirection = () => {
    const {details, setActiveDirection} = this.props
    const {value} = details
    setActiveDirection(value)
  }

  render() {
    const {details, isActive} = this.props
    const {displayText} = details

    return (
      <ListItem>
        <DirectionButton
          type="button"
          onClick={this.onClickDirection}
          isActive={isActive}
        >
          {displayText}
        </DirectionButton>
      </ListItem>
    )
  }
}

export default GradientDirectionItem
